import React from 'react';
import GroupIcon from '@material-ui/icons/Group';
import styled from "styled-components";
import useInfoCustomers from '../../Hooks/useInfoCustomers';

const Container=styled.div`
display:grid;
grid-template-columns:auto max-content;
grid-template-rows:1fr;
justify-items:center;
align-items:center;
background-color:#fbfbfd;
border:1px solid rgba(0,0,0,.08);
border-radius:3px;
padding:10px;
width:min-content;
`;

const InfoCostumers = () => 
{
    const {TotalPartys,TotalDiners} = useInfoCustomers();
    
    return <Container>
        <GroupIcon style={{color:"#757575",marginRight:"10px"}}/>
        {`${TotalPartys} | ${TotalDiners} personas`}
    </Container>
}

export default InfoCostumers
